import axios from "axios";

export default function FulfillmentCreateReceiptService(fulfillmentId, receiptGroupId) {

  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/fulfillment/" + fulfillmentId + "/createReceipt/" + receiptGroupId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
